import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { Field, FieldsGetAllParams } from 'interfaces/api/templates.interfaces'
import { CreateFieldParams, RemoveFieldParams, UpdateFieldParams } from 'interfaces/store/templates.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'
import { fieldsMapper } from 'utils/fieldsMapper'

export const getAllFields = createAsyncThunk(
  'templates/getAllFields',
  async (params: FieldsGetAllParams | undefined, { rejectWithValue }) =>
    api.templates.fields.getAll(params).catch((error) => rejectWithValue(error.message)),
)

export const getField = createAsyncThunk('templates/getField', async (id: number, { rejectWithValue }) =>
  api.templates.fields.getSingle(id).catch((error) => rejectWithValue(error.message)),
)

export const setSingleField = createAction<null | Field>('templates/setSingleField')
export const setFieldValidationErrors = createAction<ValidationErrorsApi | null>('templates/setFieldValidationErrors')

export const createField = createAsyncThunk(
  'templates/createField',
  async (params: CreateFieldParams, { rejectWithValue, dispatch }) =>
    api.templates.fields
      .create(fieldsMapper(params.data))
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setFieldValidationErrors(null))
        toast.success(Success.FieldCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setFieldValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateField = createAsyncThunk(
  'templates/updateField',
  async (params: UpdateFieldParams, { rejectWithValue, dispatch }) =>
    api.templates.fields
      .update(params.id, fieldsMapper(params.data))
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setFieldValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setFieldValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeField = createAsyncThunk(
  'templates/removeField',
  async (params: RemoveFieldParams, { rejectWithValue }) =>
    api.templates.fields
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.FieldRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)
